import { IGroup } from "../models/isearch-response"

const activeFilterElement: HTMLElement = document.querySelector(
	".prototype__filter_tag"
)
const activeFilterContainer: HTMLElement = document.querySelector(
	".result_filterName"
)
const filterCounter: HTMLElement = document.querySelector(
	".result__label"
)

export const UpdateFilterTags = (groups: IGroup[], resultCount : number): void => {
	activeFilterContainer.innerHTML = ""
	groups.forEach((filter) => {
		const filterName = filter.name;
		filter.selectedElements.forEach((activeFilter) => {
			const filterTag = activeFilterElement.cloneNode(true) as HTMLAnchorElement
			if (activeFilter.name === "true") {
				filterTag.innerHTML = `${filterName} x`
			} else {
				filterTag.innerHTML = `${activeFilter.name} x`
			}

			filterTag.setAttribute("data-url", activeFilter.searchParams)
			if (!activeFilterContainer.contains(filterTag)) {
				activeFilterContainer.append(filterTag)
			}
		})
	})
	filterCounter.innerHTML = `${resultCount.toString()} Ergebnisse`;
}
